import { render, staticRenderFns } from "./file-viewer.vue?vue&type=template&id=0c80e404&scoped=true"
import script from "./file-viewer.vue?vue&type=script&lang=js"
export * from "./file-viewer.vue?vue&type=script&lang=js"
import style0 from "./file-viewer.vue?vue&type=style&index=0&id=0c80e404&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c80e404",
  null
  
)

export default component.exports